import { render, staticRenderFns } from "./FilterList.vue?vue&type=template&id=54c64431&"
import script from "./FilterList.vue?vue&type=script&lang=js&"
export * from "./FilterList.vue?vue&type=script&lang=js&"
import style0 from "./FilterList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports